export enum IssuanceType {
  dock = 'Dock',
  winkel = 'Winkel',
  direct = 'Direct',
}
